import Vue from 'vue'
import Toast from '../components/toast'
Vue.use(Toast)
